import { forwardRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Container } from "./CommonStyles";
import { Checkbox } from "@kaltura/ds-react-components";
import styled from "@emotion/styled";
// noinspection ES6PreferShortImport
import { FormLabel } from "../form/form-label/FormLabel";

export interface CheckboxFieldProps {
    id: string;
    label: string;
    description?: string;
    value?: boolean;
    required?: boolean;
    disabled?: boolean;
    fontWeightBold?: boolean;
    className?: string;
    /*
     * props used when used to control collapsed sections
     */
    ariaExpanded?: boolean;
    ariaControls?: string;
}

const InlineContainer = styled(Container)(({ theme }) => ({
    flexDirection: "row",
    columnGap: theme.spacing(1),
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        display: "flex", // override original
    },
}));

/**
 * checkbox field
 */
export const CheckboxField = forwardRef<any, CheckboxFieldProps>(
    (
        {
            id,
            label,
            description,
            value,
            required = false,
            disabled = false,
            fontWeightBold = true,
            className,
            ariaExpanded,
            ariaControls,
        },
        ref
    ) => {
        const { control } = useFormContext();

        return (
            <InlineContainer className={className}>
                <Controller
                    control={control}
                    name={id as "dummy"}
                    defaultValue={value}
                    rules={{ required: required }}
                    render={({ field: { onChange, onBlur, value } }) => (
                        <Checkbox
                            id={id}
                            inputRef={ref}
                            onChange={onChange}
                            onBlur={onBlur}
                            checked={value}
                            disabled={disabled}
                            inputProps={{ "aria-controls": ariaControls, "aria-expanded": ariaExpanded }}
                        />
                    )}
                />
                <FormLabel htmlFor={id} text={label} required={required} fontWeightBold={fontWeightBold} />
            </InlineContainer>
        );
    }
);
